<template>  
<div> <!-- root element start -->
    <div  class="row" v-if="dataComp == 0">
      <div class="col-12 mt-4">
        <scaling-squares-spinner :animation-duration="2000" :size="65" color="#0E1698" style="margin:auto"/>
      </div>
    </div>
    <div v-if="dataComp == 1" class="row">
      <div class="col-12">
        <div class="card border-0">
          <div class="card-header bg-transparent border-0">
            <div class="row">
              <div class="col-12"><span class="h5">{{ data.name }}</span></div>
            </div>
            <div class="row">
              <div class="col-12 text-right"><a href="#" @click="editOrg(data.id)"><small>Edit Organization</small></a></div>
            </div>

          </div>
          <div class="card-body pb-1">
              <div class="row">
                <div class="col-12">
                  <span class="text-muted">Since:</span><span> {{ data.created_at | moment("MM-DD-YYYY") }}</span>
                </div>
                
                <div class="col-12">
                  <span class="text-muted">Creator:</span><span> {{ data.creatorName }}</span>
                </div>
                <div class="col-12">
                  <span class="text-muted">Status:</span><span> {{ data.statusName }}</span>
                </div>
                <div class="col-12">
                  <hr class="py-1">
                </div>
              </div>

              <div v-if="data.address != null" class="row">
                <div class="col-12"><span class="font-weight-bold">{{ data.address.name }}</span></div>
                <div class="col-12"><span class="">{{ data.address.addr1 }}</span></div>
                <div v-if="data.address.addr2 != null" class="col-12"><span class="">{{ data.address.addr2 }}</span></div>
                <div class="col-12">
                  <span class="">{{ data.address.city }},</span>
                  <span class=""> {{ data.address.state }}</span>
                  <span class=""> {{ data.address.zip }}</span>
                </div>
                <div class="col-12 text-right"><a href="#" @click="editAddress(data.address.id)"><small>Edit Address</small></a></div>
              </div>
              <div v-if="data.address == null" class="row">
                <div class="col-12"><span class="font-weight-bold">No address found! Quotes require an organization address, add one here!</span></div>
              </div>

          </div>
        </div>
      </div>
    </div>

    <hr class="bg-dark my-2">
</div> <!-- root element end -->
</template>


<script>
import { ScalingSquaresSpinner } from 'epic-spinners'
import {store} from '../../stores/org-main-store.js'


// import catMain from '../InstComponents/CategoryComponents/category-main.vue'


export default {
  store,
  data: function () {
    return { 



    }
  },
  computed: {
    data () { return this.$store.state.orgDetails },
    dataComp () { return this.$store.state.orgDetailsComp },
  },
  watch: {
    
  },
  mounted() {
    
  },
  methods: {
    changeRightView(name, prop1, prop2) { this.$store.dispatch("getRightView", { name: name, prop1: prop1, prop2: prop2 }); },
    editAddress(x) {
      var _this = this;
      _this.$emit('onSecComplete', ['launchEditAddress', x])
    },
    editOrg(x) {
      var _this = this;
      _this.$emit('onSecComplete', ['launchEditOrg', x])
    }
  },    
  components:{
    ScalingSquaresSpinner
  },
  filters: {

  }
}
</script>
